import React from 'react';
import { Box, Grid, CardContent, Card, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import './seccionPreview.scss';

export default function SeccionPreviewUsuario({ usuario }) {
    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <>
            <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                <CardContent>
                    <strong>
                        Usuario
                    </strong>
                    <Grid container spacing={0.5}>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Usuario: <strong>{usuario.Usuario}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Apellido: <strong>{usuario.Apellido}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Nombre: <strong>{usuario.Nombre}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Documento: <strong>{usuario.TipoDocumento} {usuario.NumeroDocumento}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Fecha de Nacimiento: <strong>{usuario.FechaNacimiento}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Sexo: <strong>{usuario.Sexo}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            {!usuario.TipoUsuario &&
                                <ItemR>
                                    Tipo Usuario: <Chip key={usuario.TipoUsuario} label={usuario.TipoUsuario} className='chip-preview' />
                                </ItemR>
                            }
                            {usuario.TipoUsuario &&
                                <ItemR>
                                    Tipo Usuario: -
                                </ItemR>
                            }
                        </Grid>
 <Grid size={{ xs: 6, md: 3, lg: 3 }}>
                            <ItemR>
                                Teléfono: <strong>{usuario.Telefono}</strong>
                            </ItemR>
                        </Grid>
 <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                            <ItemR>
                                Email: <strong>{usuario.Email}</strong>
                            </ItemR>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )

};